import JumpAnimationModule from './JumpAnimationModule';

export default JumpAnimationModule;
